import type { ReactNode } from 'react';
import { useCan } from '../hooks/usePermission';

/**
 * Hide UI the user cannot use. Cosmetic only — never the security boundary.
 * <Can do="workOrders.assign"><AssignButton/></Can>
 */
export function Can({ do: permission, children, fallback = null }: {
  do: string;
  children: ReactNode;
  fallback?: ReactNode;
}) {
  return useCan(permission) ? <>{children}</> : <>{fallback}</>;
}
